const cardData = [
  {
    title: "Full-Range CAD Design Services",
    description:
      "We offer highly customizable digital dental design services to meet your specific needs.",
    number: "01",
  },
  {
    title: "By Experienced Dental Professionals",
    description:
      "Led by experienced dental professionals with a keen understanding of challenges faced by labs and practices.",
    number: "02",
  },
  {
    title: "Seamless Integration",
    description:
      "Easy to use portal backed by highly trained dental CAD designers.",
    number: "03",
  },
];

const theDifference = () => {
  return (
    <div className="w-full h-full flex flex-col p-8 md:p-[5vw] gap-[3vw] bg-transparent">
      <h1 className="text-2xl md:text-[4vw] font-bold md:leading-[4vw]">
        The ToothSketch Difference
      </h1>
      <div className="w-full h-full flex flex-col md:flex-row gap-6 md:gap-[3vw]">
        {cardData.map((item, index) => (
          <div
            key={index}
            className="w-full min-h-[30vh] md:min-h-[15vw] border-[0.2vw] border-white rounded-2xl md:rounded-[1vw] p-4 md:p-[2vw] flex flex-col items-center justify-center md:gap-[1vw] gap-4"
          >
            <div className="w-full h-auto flex flex-col md:flex-row font-semibold justify-center gap-4">
              <p className="md:border-r-[0.2vw] border-white md:pr-[1vw] text-5xl md:text-[4vw] flex items-center justify-center">
                {item.number}
              </p>
              <p className="md:text-[2vw] px-2 md:px-0 text-2xl text-center md:text-start md:pl-[1vw] md:leading-none flex items-center justify-center">
                {item.title}
              </p>
            </div>
            <div className="w-full h-auto flex flex-col justify-center items-center">
              <p className="text-center text-md md:text-[1.3vw] md:leading-[1.5vw]">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default theDifference;
